// @ts-strict-ignore
import type { CryptopediaCategoryType } from "types/cryptopedia";

// Used if contentful call on mobile nav bar fails
export const FALLBACK_TOP_CATEGORIES: CryptopediaCategoryType[] = [
  {
    id: "3QiSvBd10ev5P3aLbYZt65",
    name: "Cryptocurrencies",
    description: "",
    featuredImage: {},
    parentCategory: null
  },
  {
    id: "6t3mWZsVVXorbdxsFoMn47",
    name: "Security",
    description: "",
    featuredImage: {},
    parentCategory: null
  },
  {
    id: "2vaRGhu1Howzer4zPhRvqM",
    name: "Trading & Investing",
    description: "",
    featuredImage: {},
    parentCategory: null
  },
  {
    id: "5Ockt4IPmePUg4mDJO52A1",
    name: "Defi",
    description: "",
    featuredImage: {},
    parentCategory: null
  }
];
